// src/components/dialog/DlgNewsPoolInfo.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material'
import { ReactNode } from 'react'

import { NewsPool } from '@/types/domain/news'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import {
  FILTER_BUSINESS_NEWS_TYPE,
  FILTER_LEGAL_NEWS_TYPE,
  FILTER_TECH_NEWS_TYPE,
  FILTER_UNSPECIFIED_NEWS_TYPE,
} from '../../api/'
import { DlgCloseButton, HStack } from '../../components'
import { useNewsPool } from '../../hooks'

type StatRecordProps = {
  label: ReactNode
  value: ReactNode
  sx?: SxProps<Theme>
}

const StatRecord = ({ label, value, sx }: StatRecordProps) => (
  <HStack spacing={2} sx={{ width: 1, ...sx }}>
    <Stack sx={{ flex: 1, textAlign: 'right' }}>
      <Typography>{label}</Typography>
    </Stack>
    <Stack sx={{ flex: 1, textAlign: 'left' }}>
      <Typography>{value}</Typography>
    </Stack>
  </HStack>
)

const NewsPoolStat = () => {
  const nPool: NewsPool = useNewsPool()

  return (
    <Stack sx={{ mt: 3 }}>
      <StatRecord label={'Poolgröße'} value={nPool.length} />

      <StatRecord
        label={<strong>Kategorie</strong>}
        value={null}
        sx={{ my: 1, pr: 1, textAlign: 'right' }}
      />

      {[
        {
          label: 'Vertrags News',
          value: nPool.filter(f => f.attributes.contract_id !== null).length,
        },
        {
          label: 'Gebäude News',
          value: nPool.filter(f => f.attributes.folder_id !== null).length,
        },
        {
          label: 'unspezifiziert',
          value: nPool.filter(
            f =>
              f.attributes.contract_id === null &&
              f.attributes.folder_id === null
          ).length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}

      <StatRecord
        label={<strong>Rubrik</strong>}
        value={null}
        sx={{ my: 1, pr: 1, textAlign: 'right' }}
      />

      {[
        {
          label: 'technisch',
          value: nPool.filter(FILTER_TECH_NEWS_TYPE).length,
        },
        {
          label: 'rechtlich',
          value: nPool.filter(FILTER_LEGAL_NEWS_TYPE).length,
        },
        {
          label: 'kaufmännisch',
          value: nPool.filter(FILTER_BUSINESS_NEWS_TYPE).length,
        },
        {
          label: 'unspezifiziert',
          value: nPool.filter(FILTER_UNSPECIFIED_NEWS_TYPE).length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}
    </Stack>
  )
}

export const DlgNewsPoolInfo = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>
      <Typography>News Pool Info</Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent>
      <NewsPoolStat />
    </DialogContent>
  </Dialog>
)
